<template>
    <div class="form-group">
        <div v-for="(office, key) in officeStore.offices" class="my-2">
            <div class="position-relative">
                <input type="text" class="form-control wfh-version mb-2" :value="office.text" disabled>
                <button
                    class="task-checkbox btn p-0 m-2 border-0 d-flex align-items-center justify-content-center shadow-none position-absolute"
                    style="opacity: 100%;padding:0 !important;background-color: #ffffff;width: 24px;height: 24px;top:0;right:0;"
                    @click="officeStore.removeOffice(key)"
                >
                    <img :src="'/images/close_icon.png'" height="10px"/>
                </button>
            </div>
            <label v-if="officeStore.offices.length > 1" class="font-weight-light d-flex align-items-center"
                   style="cursor: pointer">
                <button
                    class="task-checkbox btn p-0 m-2 border-0 d-flex align-self-center shadow-none"
                    style="opacity: 100%;padding:0 !important;background-color: #F2F2F2;width: 24px;height: 24px;"
                    @click="officeStore.setDefaultOffice(key)"
                >
                    <img :src="'/images/checkbox_checked.png'" v-if="office.isDefault"/>
                </button>
                Set as default admin timezone</label>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['officeStore']
    }
</script>

<style scoped lang="scss">
    .task {
        border-radius: 0.25rem;
        flex-wrap: wrap;

        .task-title {
            height: auto;
            line-height: 1.3em;
        }

        .task-title-input {
            resize: none;
            overflow: hidden;
            border-radius: 3px 0 0 3px;
            line-height: 1.3em;
        }

        .task-time {
            font-size: 0.6rem;
            line-height: 1.2em;
            max-width: 60px;
            white-space: normal;
        }

        .task-checkbox {
            height: 23px;
            width: 23px;
        }
    }
</style>
